import { Component, OnInit } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { RowArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { IHMSStudentResponse } from '../../interfaces/ihms-dashboard-response';
import { IhmsGridStatus } from '../../enums/ihms-grid-status';
import { IhmsService } from '../../services/ihms.service';
import { NotificationService } from '@progress/kendo-angular-notification';
import { IIhmsEventLog } from '../../interfaces/ihms-events-response';
import { ICompleteActionPayload } from '../../interfaces/complete-action-payload';
import { CompleteIhms } from '../../models/complete-ihms';
import { ApiResponse } from '../../interfaces/api-response';
import {
  IhmsNotificationMessages,
  IhmsNotificationMessageKeys,
} from '../../constants/notification-messages';
import { IIhmsSavePayload } from '../../interfaces/ihms-save-payload';

@Component({
  selector: 'app-complete-action-item',
  templateUrl: './complete-action-item.component.html',
  styleUrls: ['./complete-action-item.component.scss'],
  standalone: false,
})
export class CompleteActionItemComponent
  extends DialogContentBase
  implements OnInit
{
  mySelection: IIhmsEventLog[] = [];
  selectedAddedEvents: IIhmsEventLog[] = [];
  addedEvents: IIhmsEventLog[] = [];
  actionDetails: IHMSStudentResponse;
  studentId: string;
  studentName: string;
  completedEvents: IIhmsEventLog[] = [];
  loadSpinner: boolean = false;

  constructor(
    dialogRef: DialogRef,
    library: FaIconLibrary,
    public ihmsService: IhmsService,
    private notificationService: NotificationService
  ) {
    library.addIcons(faTriangleExclamation);
    super(dialogRef);
  }

  ngOnInit(): void {
    this.getEventLogList();
  }

  getEventLogList(): void {
    this.ihmsService.loadingEvents = true;
    this.ihmsService
      .getEventLogs(this.studentId, this.actionDetails.name)
      .subscribe((response: IIhmsEventLog[]) => {
        this.ihmsService.loadingEvents = false;
        this.completedEvents = response;
      });
  }
  addEvent(data: IIhmsEventLog): void {
    this.addedEvents = [...this.addedEvents, data];
  }
  isEventAlreadyAdded(event: IIhmsEventLog): boolean {
    return this.addedEvents.some(
      (e: IIhmsEventLog) => e.studentSk === event.outreachSk
    );
  }
  onSelectionChange(event: SelectionEvent): void {
    this.selectedAddedEvents = event.selectedRows.map(
      (row: RowArgs) => row.dataItem
    );
  }
  removeSelectedEvents(): void {
    //Remove selected from addedEvents
    this.addedEvents = this.addedEvents.filter(
      (event: IIhmsEventLog) => !this.selectedAddedEvents.includes(event)
    );
    //Clear checkbox selection:
    this.mySelection = [];
  }

  getStatus(status: number): string {
    if (status === IhmsGridStatus.Assigned) {
      return 'Assigned';
    } else if (status === IhmsGridStatus.New) {
      return ' New';
    } else if (status === IhmsGridStatus.Returned) {
      return ' Returned';
    } else if (status === IhmsGridStatus.Completed) {
      return 'Completed';
    } else if (status === IhmsGridStatus.SubmittedForReview) {
      return 'Submitted For Review';
    }
    return '';
  }

  completeEvent(): void {
    this.loadSpinner = true;
    const payload: ICompleteActionPayload = new CompleteIhms({
      actionItemId: this.actionDetails?.action_Item_Id,
      documentInfo: this.addedEvents.map((ev: IIhmsEventLog) => {
        return ev.documentDetails;
      }),
    });
    this.ihmsService.completeActionItem(payload).subscribe({
      next: (res: ApiResponse<IIhmsSavePayload>) => {
        if (res.isRequestSucessful) {
          const message: string = IhmsNotificationMessages[
            IhmsNotificationMessageKeys.CompletedSuccess
          ](this.actionDetails.name);
          this.notificationService.show({
            content: message,
            cssClass: 'notification-message-class-ihms',
            position: { horizontal: 'center', vertical: 'top' },
            animation: { type: 'slide', duration: 60 },
            type: { style: 'success', icon: true },
            closable: false,
          });
        }
        this.ihmsService.getReloadIhmsGridDetails(true);
        this.dialog.close();
        this.loadSpinner = false;
      },
      error: () => {
        this.loadSpinner = false;
        this.notificationService.show({
          content: 'Complete Action Item Failed',
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: 60 },
          type: { style: 'error', icon: true },
          closable: true,
        });
      },
    });
  }
}
